import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ChatMessage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetPageChatMessagesStaticFilter } from '../../endpoints/pages';

export const getPageChatMessages = async (
  params: GetCollectionQueryParams<ChatMessage, GetPageChatMessagesStaticFilter>,
): Promise<ApiCollectionResponse<ChatMessage>> => {
  return await tinctApi.pages.getPageChatAgentMessages(params);
};

export const useGetPageChatMessages = (
  params: GetCollectionQueryParams<ChatMessage, GetPageChatMessagesStaticFilter>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ChatMessage>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    // 'chat-agent-messages' at index 2 is load-bearing: the studio's
    // invalidation predicates match ['pages', pageId, …] and exclude this
    // segment so an in-flight stream's history is never refetched mid-stream.
    queryKey: ['pages', params.staticParams?.pageId, 'chat-agent-messages', params],
    queryFn: () => getPageChatMessages(params),
    ...options,
  });
